import { fr } from "@/i18n/fr";
import { PartsChips } from "./PartsChips";
import { StepList } from "./StepList";

export function Sidebar() {
	return (
		<aside className="sidebar">
			<h3>{fr.steps}</h3>
			<StepList />
			<PartsChips />
			<div className="hint">{fr.hint}</div>
		</aside>
	);
}
